/// <amd-module name="TFS/Admin/Groups/Pivots/GroupMembers/Components/GroupMembersPivot" />
import * as React from "react";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { DynamicModuleLoader } from "redux-dynamic-modules";
import { ConnectedGroupMembersPivotInitializer } from "TFS/Admin/Groups/Pivots/GroupMembers/Components/GroupMembersPivotInitializer";
import { getGroupMembersPivotModule } from "TFS/Admin/Groups/Pivots/GroupMembers/Redux/GroupMembersPivotModule";

export interface IMembersPivotProps extends IPivotProps {}

export class GroupMembersPivot extends VssComponent<IMembersPivotProps> {
    constructor(props: IMembersPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <DynamicModuleLoader modules={[getGroupMembersPivotModule()]}>
                <ConnectedGroupMembersPivotInitializer filter={this.props.filter} pageContext={this.context.pageContext} />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("ms.vss-admin-web.orggroups-group-members-pivot", GroupMembersPivot);
